import React, { createContext, useState, useContext } from 'react';

const InertiaVisitContext = createContext();

export const InertiaVisitProvider = ({
  children,
  defaultMessage = 'Please hold on a moment.'
}) => {
  const [canNavigate, setCanNavigateState] = useState(true);
  const [navigateMessage, setNavigateMessage] = useState(defaultMessage);

  const setCanNavigate = (state = true, navigateMessage = null) => {
    setCanNavigateState(state);
    setNavigateMessage(navigateMessage || defaultMessage);
  };

  return (
    <InertiaVisitContext.Provider
      value={{
        canNavigate,
        setCanNavigate,
        navigateMessage,
        setNavigateMessage
      }}
    >
      {children}
    </InertiaVisitContext.Provider>
  );
};

/**
 * @typedef {Object} InertiaVisit

 * @property {boolean} canNavigate
 * @property {function(boolean, string): void} setCanNavigate
 * @property {string} navigateMessage
 * @property {function(string): void} setNavigateMessage
 */

/**
 * useCanNavigate
 *
 * @returns {InertiaVisit} Steps context value.
 */
export const useCanNavigate = () => useContext(InertiaVisitContext);
